// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"455":"original","596":"sketchy"}[chunkId] + ".bundle." + {"455":"cbb1624f89383302d859","596":"36e17006a5129d780409"}[chunkId] + ".js";
};